<div class="row" style="border-bottom: 2px solid #ccc; margin-bottom: 10px">
  <div
    class="col-sm-11 movable"
    cdkDrag
    cdkDragHandle
    cdkDragRootElement=".cdk-overlay-pane"
  >
    <h3 class="head">Batch Trigger</h3>
    <div class="successMessage alert-dismissible">
      <div *ngIf="warningMessage" class="alert alert-warning" role="alert">
        {{ warningMessage }}
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>

      <div *ngIf="successMessage" class="alert alert-success" role="alert">
        {{ successMessage }}
        <button
          type="button"
          class="btn-close"
          (click)="removeMessage()"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
    </div>
  </div>
  <div class="col-sm-1">
    <button
      type="button"
      class="btn btn-dark btn-circle btn-xl"
      mat-dialog-close="cancel"
      data-dismiss="modal"
      aria-label="Close"
    >
      <span aria-hidden="true">×</span>
    </button>
  </div>
</div>
<div *ngIf="!isMonthlyPipeline">
<div class="container-fluid">
  <div class="row">
    <div class="col-xl-1 col-md-2 col-sm-3 dropwidth">
      <div class="drpchildctrl">
        <span class="v1"></span>
        <label class="searchLable">DOCK</label>
        <p-dropdown
          [showTransitionOptions]="'0ms'"
          [hideTransitionOptions]="'0ms'"
          autoWidth="true"
          [resetFilterOnHide]="true"
          [virtualScroll]="true"
          [itemSize]="10"
          placeholder="Select"
          [style]="{ width: '100%' }"
          scrollHeight="100px"
          [options]="dockList"
          optionLabel="dock"
          appendTo="body"
          [(ngModel)]="selectedDock"
          [filterBy]="'dock'"
          (onChange)="onDockChange()"
        ></p-dropdown>
      </div>
    </div>
    <div class="col-xl-1 col-md-2 col-sm-3 dropwidth">
      <div class="drpchildctrl">
        <label class="searchLable">KANBAN</label>

        <p-dropdown
          [showTransitionOptions]="'0ms'"
          [hideTransitionOptions]="'0ms'"
          autoWidth="true"
          [resetFilterOnHide]="true"
          [virtualScroll]="true"
          [itemSize]="25"
          [filter]="true"
          placeholder="Select"
          [style]="{ width: '100%' }"
          [disabled]="disableKanban"
          scrollHeight="100px"
          [options]="kanbanList"
          optionLabel="kanban"
          appendTo="body"
          [(ngModel)]="selectedKanban"
          [filterBy]="'kanban'"
          (onChange)="onKanbanChange()"
        ></p-dropdown>
      </div>
    </div>
    <div class="col-xl-1 col-md-2 col-sm-3 dropwidth">
      <div class="drpchildctrl">
        <label class="searchLable">PART NO</label>

        <p-dropdown
          [showTransitionOptions]="'0ms'"
          [hideTransitionOptions]="'0ms'"
          autoWidth="true"
          [resetFilterOnHide]="true"
          [virtualScroll]="true"
          [itemSize]="25"
          [filter]="true"
          placeholder="Select"
          [style]="{ width: '100%' }"
          (onChange)="onPartNoChange()"
          scrollHeight="100px"
          [options]="partList"
          optionLabel="item_id"
          appendTo="body"
          [(ngModel)]="selectedPart"
          [filterBy]="'item_id'"
          [disabled]="disablePartNumber"
        ></p-dropdown>
      </div>
    </div>
   
    <div class="col-4 col-lg-3">
      <label class="searchLable">{{dataLabel}}</label>
      <input
        class="form-control-sm"
        type="date"
        [(ngModel)]="selectedDate"
        style="width: 90%; max-width: 200px"
      />
    </div>
  </div>
</div>
</div>

<!-- Button row at the bottom -->
<div *ngIf="isMonthlyPipeline" >
  <p *ngIf="!disableTriggerButton">
    Are you sure you want to trigger this batch?
  </p>

  <p *ngIf="disableTriggerButton" class="text-danger">
    {{ displaywarningmsg}}
  </p>
</div>
<div class="row mt-4">
  <div class="col-12 text-end">
<button
  class="review_btn me-2"
  (click)="triggerBatch()"
  [disabled]="disableTriggerButton"
  [ngClass]="{ 'disabled-btn': disableTriggerButton }"
  mat-button
>
  Trigger Batch
</button>
    <button class="cancel_btn" mat-button mat-dialog-close="cancel">
      Cancel
    </button>
  </div>
</div>
